import React from 'react';
import { WorkStatus } from '../../types';
import {
  TrendingUp,
  Clock,
  CheckCircle,
  AlertCircle,
  XCircle
} from 'lucide-react';

interface ProjectStatusBadgeProps {
  status: WorkStatus;
  label: string;
  size?: 'sm' | 'md';
}

export const getStatusConfig = (status: WorkStatus) => {
  switch (status) {
    case WorkStatus.EN_CONSTRUCCION:
      return {
        color: 'bg-orange-200 text-orange-900 border-orange-300',
        dotColor: 'bg-orange-700',
        icon: <TrendingUp className="w-3.5 h-3.5" />
      };
    case WorkStatus.PLANIFICACION:
      return {
        color: 'bg-yellow-200 text-yellow-900 border-yellow-300',
        dotColor: 'bg-yellow-700',
        icon: <Clock className="w-3.5 h-3.5" />
      };
    case WorkStatus.FINALIZADO:
      return {
        color: 'bg-green-200 text-green-900 border-green-300',
        dotColor: 'bg-green-700',
        icon: <CheckCircle className="w-3.5 h-3.5" />
      };
    case WorkStatus.SUSPENDIDO:
      return {
        color: 'bg-gray-300 text-gray-900 border-gray-400',
        dotColor: 'bg-gray-700',
        icon: <AlertCircle className="w-3.5 h-3.5" />
      };
    case WorkStatus.CANCELADO:
      return {
        color: 'bg-red-200 text-red-900 border-red-300',
        dotColor: 'bg-red-700',
        icon: <XCircle className="w-3.5 h-3.5" />
      };
    default:
      return {
        color: 'bg-gray-300 text-gray-900 border-gray-400',
        dotColor: 'bg-gray-700',
        icon: <Clock className="w-3.5 h-3.5" />
      };
  }
};

export const ProjectStatusBadge: React.FC<ProjectStatusBadgeProps> = ({ 
  status, 
  label,
  size = 'md'
}) => {
  const config = getStatusConfig(status);
  const textSize = size === 'sm' ? 'text-[10px]' : 'text-xs';

  return (
    <div 
      className={`${config.color} inline-flex items-center gap-2 w-fit border rounded-full px-3 py-1`}
    >
      <span className={`block h-1.5 w-1.5 rounded-full ${config.dotColor}`} />
      <span className={`${textSize} font-medium uppercase tracking-wide`}>
        {label}
      </span>
    </div>
  );
};

// Versión alternativa con ícono en lugar de punto
export const ProjectStatusBadgeWithIcon: React.FC<ProjectStatusBadgeProps> = ({ 
  status, 
  label,
  size = 'md'
}) => {
  const config = getStatusConfig(status);
  const textSize = size === 'sm' ? 'text-[10px]' : 'text-xs';

  return (
    <div 
      className={`${config.color} inline-flex items-center gap-1.5 w-fit border rounded-full px-3 py-1`}
    >
      {config.icon}
      <span className={`${textSize} font-medium uppercase tracking-wide`}>
        {label}
      </span>
    </div>
  );
};
